import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { LoginModel, UserModel } from '@app/models';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService
{
    isLoggedIn = signal<boolean>(false);

    private endPoint = '/auth';
    private http = inject(HttpClient);

    verify(): Promise<boolean>
    {
        const url = `${this.endPoint}/verify`;

        return firstValueFrom(this.http.get<boolean>(url));
    }

    login(credentials: LoginModel): Promise<{ token: string; user: UserModel, need_change_password: boolean, }>
    {
        const url = `${this.endPoint}`;

        return firstValueFrom(this.http.post<{
            token: string;
            user: UserModel,
            need_change_password: boolean,
        }>(url, credentials));
    }

    me(): Promise<UserModel>
    {
        const url = `${this.endPoint}/me`;

        return firstValueFrom(this.http.get<UserModel>(url));
    }

    logout(): Promise<boolean>
    {
        const url = `${this.endPoint}/logout`;

        return firstValueFrom(this.http.get<boolean>(url));
    }
}
